module.exports = __webpack_public_path__ + "static/media/checkYourself_48.c891242e.png";